













import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LanguageSwitcher extends Vue {
  public change(lang: string) {
    this.$i18n.locale = lang;
  }
}
